import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export const useDepartments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    axios.get(`${API}/api/employees/departments`, { headers })
      .then(r => setDepartments(r.data || []))
      .catch(() => setDepartments([]))
      .finally(() => setLoading(false));
  }, []);

  // Returns department names for use in <MenuItem> and filter dropdowns
  const names = departments.map(d => d.name);

  return { departments, names, loading };
};
